import { CSVOrderImport } from "../../../api/types/settings"
import { FormErrors } from "../../FieldError"

export const validateSettings = (settings: CSVOrderImport): [boolean, FormErrors<CSVOrderImport>] => {
  let errors: FormErrors<CSVOrderImport> = {}

  if (!settings.separator) {
    errors.separator = "Oddělovač je povinné pole."
  }

  if (!settings.encoding) {
    errors.encoding = "Kódování je povinné pole."
  }

  return [
    Object.keys(errors).length === 0,
    errors
  ]
}

